import { formatFractionDisplay } from '@core/utils/fraction';

export function toMeasurementNumber(
  value: string | number | null | undefined
): number | undefined {
  if (value == null) {
    return undefined;
  }
  if (typeof value === 'number') {
    return Number.isFinite(value) ? Math.round(value * 1000) / 1000 : undefined;
  }
  const trimmed = value.trim();
  if (trimmed === '') {
    return undefined;
  }
  const parsed = Number.parseFloat(trimmed);
  if (!Number.isFinite(parsed)) {
    return undefined;
  }
  return Math.round(parsed * 1000) / 1000;
}

export function formatMeasurement(
  measurement?: string | number | null
): string | null {
  const m = String(measurement ?? '').trim();
  if (m === '') {
    return null;
  }
  const formatted = formatFractionDisplay(m);
  if (formatted === '') {
    return null;
  }
  return `${formatted}″`;
}
